var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.333 12.666H12.667c-3.515 0-6.302 2.819-6.302 6.334l-.032 38a6.312 6.312 0 006.334 6.333h50.666A6.312 6.312 0 0069.667 57V19a6.311 6.311 0 00-6.334-6.334zM60.167 57H15.833a3.176 3.176 0 01-3.166-3.167V38h50.666v15.833A3.176 3.176 0 0160.167 57zm3.166-31.667H12.667V19h50.666v6.333z",
    fill: "#4A4A4A"
  })));
}
export default __webpack_public_path__ + "static/media/CreditCardRounded.8b21ef5a.svg";
export { SvgCreditCardRounded as ReactComponent };